export default __webpack_public_path__ + "static/media/SUI.23c0781a.png";